import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const AttestPlaidCredentialsRequest = z.object({
  transactions: z.unknown(),
  numberOfDaysBack: z.number(),
  institutionId: z.string(),
  userPublicId: z.string(),
})

export type AttestPlaidCredentialsRequest = z.infer<typeof AttestPlaidCredentialsRequest>

export const AttestPlaidCredentialsResponse = z.object({})

export type AttestPlaidCredentialsResponse = z.infer<typeof AttestPlaidCredentialsResponse>

export const attestPlaidCredentialsDeclaration = endpointDeclaration(
  AttestPlaidCredentialsRequest,
  AttestPlaidCredentialsResponse,
)
